import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTopAndHash() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      // Vent et øjeblik på at DOM'en er renderet
      const timer = setTimeout(() => {
        const element = document.querySelector(hash)
        if (element) {
          const offset = 80 // højde af navbar
          const bodyRect = document.body.getBoundingClientRect().top
          const elementRect = element.getBoundingClientRect().top
          const elementPosition = elementRect - bodyRect
          const offsetPosition = elementPosition - offset

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
        }
      }, 100)
      return () => clearTimeout(timer)
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [pathname, hash])

  return null
}
